export { captureException, ErrorBoundary } from '@sentry/react';

export const captureExceptionVoid = (_: unknown) => {};
